import React from 'react';

import IconSearch from 'assets/icons/search.svg';
import IconWriting from 'assets/icons/writing.svg';

import * as S from './styles';
import { cpfMask, phoneMask } from 'utils/mask';

function CardClient({
  data,
  onClickSearch,
  onClickWriting,
  isLoading = false
}) {
  return (
    <S.Container>
      <S.Content>
        <S.ContentStatus>
          <S.Title>Nome completo</S.Title>
          <S.Subtitle>{data?.nome}</S.Subtitle>
        </S.ContentStatus>
      </S.Content>
      <S.Line />

      <S.Content>
        <S.ContentStatus>
          <S.Title>CPF</S.Title>
          <S.Subtitle>{cpfMask(data?.cpf).masked}</S.Subtitle>
        </S.ContentStatus>
      </S.Content>
      <S.Line />

      <S.Content>
        <S.ContentStatus>
          <S.Title>E-mail</S.Title>
          <S.Subtitle>{data?.email}</S.Subtitle>
        </S.ContentStatus>
      </S.Content>
      <S.Line />

      <S.Content>
        <S.ContentStatus>
          <S.Title>Telefone</S.Title>
          <S.Subtitle>{phoneMask(data?.celular).masked}</S.Subtitle>
        </S.ContentStatus>
        {isLoading ? (
          <S.ContentIcon>
            <S.SpinnerCusmotized />
          </S.ContentIcon>
        ): (
          <S.ContentIcon>
            {onClickSearch && <S.Search src={IconSearch} onClick={() => onClickSearch(data)} />} 
            {onClickWriting && <S.Writing src={IconWriting} onClick={() => onClickWriting(data)} />}
          </S.ContentIcon>
        )}
      </S.Content>
    </S.Container>
  )
}

export default CardClient
